import React, { useEffect, useState } from "react";
import { EyeOutlined } from "@ant-design/icons";
import { FiBell } from "react-icons/fi";
import { Button, Dropdown } from "antd";
import useGet from "../services/useGet";
import { formatDate } from "../utils/helper";
import { useHistory } from "react-router-dom";
import LocalStorageService from "../utils/localStorageServices";

const Notifications = () => {
  const [notificationStatus] = useState("unread");
  const [notificationReadStatus] = useState("read");
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const history = useHistory()

  const { callApi: getNotifications, data: notifications } = useGet({
    endpoint: `notification/list/filter?readStatus=${notificationStatus}`,
  });
  const { callApi: getAllNotifications, data: Allnotifications } = useGet({
    endpoint: `notification/list/filter?readStatus=${notificationReadStatus}`,
  });

  useEffect(() => {
    getNotifications();
    getAllNotifications();
  }, []);

  const currentUser = LocalStorageService.getService().getCurrentUser();
  const userTimezone = currentUser?.user?.timezone?.name;

  const customStatusNotifications = [];
  if (currentUser?.user && currentUser?.user?.paymentStatus === false) {
    customStatusNotifications.push({
      _id: "payment_pending",
      notifyText: "Please pay your outstandings.",
      link: "/profile?payment=true",
      readStatus: "unread",
      isCustom: true,
      actionText: "Pay now",
      createdAt: new Date().toISOString()
    });
  }

  if (userTimezone === null || userTimezone === "") {
    customStatusNotifications.push({
      _id: "timezone_not_setup",
      notifyText: "You have not setup your timezone.",
      link: "/profile?edit=true",
      readStatus: "unread",
      isCustom: true,
      actionText: "Setup now",
      createdAt: new Date().toISOString()
    });
  }

  const allNotificationsMerged = [
    ...customStatusNotifications,
    ...(Array.isArray(notifications) ? notifications : []),
    ...(Array.isArray(Allnotifications) ? Allnotifications : []),
  ].sort((a, b) => {
    if (a.isCustom && !b.isCustom) return -1;
    if (!a.isCustom && b.isCustom) return 1;
    return (a.readStatus === "unread" ? -1 : 1);
  });

  const unreadCount =
    allNotificationsMerged?.filter((n) => n.readStatus === "unread").length ||
    0;


  return (
    <>
      <Dropdown
        onOpenChange={setDropdownVisible}
        open={dropdownVisible}
        popupRender={() => (
          <div className="bg-white w-[400px] h-[400px] rounded-md shadow-lg flex flex-col overflow-hidden ">
            {/* HEADER */}
            <div className="px-3 py-2 border-b border-secondary/15 sticky top-0 bg-white z-10">
              <div className="flex items-center justify-between">
                <h1 className="text-lg font-medium">Notifications</h1>
                {unreadCount > 0 && (
                  <span className="text-sm text-gray-500 cursor-pointer" onClick={() => history.push("/notifications")}>
                    {unreadCount} unread
                  </span>
                )}
              </div>
            </div>

            {/* SCROLLABLE CONTENT */}
            <div className="flex-1 overflow-y-auto">
              {Array.isArray(allNotificationsMerged) &&
                allNotificationsMerged.length > 0 ? (
                allNotificationsMerged.map((notification, idx) => (
                  <div
                    key={notification._id || notification.id}
                    onClick={() => {
                      notification.link && history.push(notification.link)
                      setDropdownVisible(false)
                    }}
                    className={`px-4 py-3 hover:bg-gray-50 transition-colors cursor-pointer border-b border-secondary/15 border-l-2 ${notification.readStatus === "unread"
                      ? "border-l-primary bg-blue-50/30"
                      : "border-l-transparent"
                      } hover:border-l-primary ${idx === allNotificationsMerged.length - 1 ? "border-b-0" : ""
                      }`}
                  >
                    <div className="flex items-start justify-between gap-2">
                      <h3 className="block line-clamp-2 text-sm font-semibold text-gray-800">
                        {notification.notifyText?.replace(/<br\/?>/g, " ")}
                        {notification.isCustom && (
                          <span className="ml-2 text-xs text-primary font-medium underline">
                            {notification.actionText}
                          </span>
                        )}
                      </h3>
                      {notification.readStatus === "unread" && (
                        <div className="w-2 h-2 rounded-full !bg-primary flex-shrink-0 mt-1"></div>
                      )}
                    </div>
                    <span className="block mt-2  text-xs text-secondary font-medium">
                      {formatDate(notification?.createdAt)}
                    </span>
                  </div>
                ))
              ) : (
                <div className="flex flex-col items-center justify-center h-full py-8 text-center">
                  <p className="text-sm text-gray-500 font-medium">
                    🎉 You’re all caught up!
                  </p>
                  <p className="text-xs text-gray-400 mt-1">
                    No new notifications at the moment.
                  </p>
                </div>
              )}
            </div>

            {/* FOOTER */}
            <div className="px-3 py-2 border-t border-secondary/15 sticky bottom-0 bg-white z-10 flex justify-center">
              <Button
                className="!bg-primary text-white w-full hover:!bg-primary hover:!border-primary text-sm font-medium h-9"
                icon={<EyeOutlined />}
                onClick={() => {
                  history.push("/notifications")
                  setDropdownVisible(false)
                }}
              >
                View all notifications
              </Button>
            </div>
          </div>
        )}
        trigger={["click"]}
      >
        <Button
          onClick={(e) => e.preventDefault()}
          className="cursor-pointer hover:!bg-transparent hover:!text-primary !border-none sm:block hidden"
        >
          <div className="relative">
            {unreadCount > 0 && (
              <div className="absolute -top-[6px] -right-1 size-2 rounded-full !bg-primary"></div>
            )}
            <FiBell size={24} className="" />
          </div>
        </Button>
      </Dropdown>
      <Button
        onClick={(e) => history.push("/notifications")}
        className="cursor-pointer hover:!bg-transparent hover:!text-primary !border-none sm:hidden block"
      >
        <div className="relative">
          {unreadCount > 0 && (
            <div className="absolute -top-[6px] -right-1 size-2 rounded-full !bg-primary"></div>
          )}
          <FiBell size={24} className="" />
        </div>
      </Button>
    </>
  );
};

export default Notifications;
